<div class="plans-container">
  <umkt-loading [size]="'lg'" [isLoading]="isLoading" [showText]="true" [text]="'pages.plans.loading' | i18n" mode="overlay"></umkt-loading>

  <div class="breadcrumb-section">
    <umkt-breadcrumb [items]="breadcrumbItems" [separator]="'>'"></umkt-breadcrumb>
  </div>

  <div class="page-header">
    <div class="title-section">
      <h1 class="page-title">{{ 'shared.labels.plans' | i18n }}</h1>
    </div>
  </div>

  <div class="plans-content-card" *ngIf="!error">
    <div class="filter-section" *ngIf="!isLoading">
      <div class="search-input-wrapper">
        <umkt-custom-input
          [placeholder]="'shared.placeholders.searchKeyword' | i18n"
          [(ngModel)]="searchTerm"
          (searchSubmit)="onSearch()"
          [showClearButton]="true"
          [showPasswordToggle]="false"
          [showSearchIcon]="true"
          type="text">
        </umkt-custom-input>
      </div>
      
      <div class="separator">|</div>
      
      <div class="filter-controls">
        <div class="select-wrapper">
          <label class="floating-label" for="filter-select">{{ 'pages.plans.filterLabel' | i18n }}</label>
          <select id="filter-select" class="custom-select" 
                  [(ngModel)]="selectedFilter" 
                  (change)="onFilterChange()">
            <option *ngFor="let option of filterOptions" [value]="option.value">
              {{ option.label | i18n }}
            </option>
          </select>
          <div class="select-arrow"></div>
        </div>
      </div>
      
      <div class="order-controls">
        <div class="select-wrapper">
          <label class="floating-label" for="order-select">{{ 'pages.plans.orderLabel' | i18n }}</label>
          <select id="order-select" class="custom-select" 
                  [(ngModel)]="selectedOrder" 
                  (change)="onOrderChange()">
            <option *ngFor="let option of orderOptions" [value]="option.value">
              {{ option.label | i18n }}
            </option>
          </select>
          <div class="select-arrow"></div>
        </div>
      </div>
    </div>

    <div *ngIf="!isLoading && !error">
      <div class="plans-section" *ngIf="planPanels.length > 0">
        <umkt-plan-panel [plans]="planPanels" [preserveOpenState]="true"
          (planDetails)="onPlanDetails($event)" (managePlan)="onManagePlan($event)">
        </umkt-plan-panel>
      </div>

      <div class="pagination-bottom" *ngIf="planPanels.length > 0">
        <div class="pagination-layout">
          <div class="pagination-left-section">
            <div class="pagination-items-per-page">
              <span class="pagination-text">{{ 'pages.plans.itemsPerPage' | i18n }}</span>
              <div class="pagination-selector">
                <select [(ngModel)]="itemsPerPage" (ngModelChange)="onItemsPerPageSelectorChange($event)"
                  (focus)="onSelectorFocus()" (blur)="onSelectorBlur()" class="pagination-select"
                  [class.active]="itemsPerPage || isSelectorFocused">
                  <option *ngFor="let option of itemsPerPageOptions" [value]="option">
                    {{ formatItemsPerPageOption(option) }}
                  </option>
                </select>
              </div>
            </div>

            <div class="pagination-separator">|</div>

            <div class="pagination-info-left">
              <span class="pagination-info">{{ getPageInfoText() | i18n: getPageInfoParams() }}</span>
            </div>
          </div>

          <div class="pagination-navigation">
            <button class="pagination-btn first-btn" [disabled]="currentPage <= 0" (click)="goToPage(0)">
              {{ 'pages.plans.pagination.first' | i18n }}
            </button>
            <button class="pagination-btn prev-btn" [disabled]="currentPage <= 0" (click)="goToPreviousPage()">
              &lt;
            </button>

            <ng-container *ngFor="let page of getVisiblePages(); let i = index">
              <button *ngIf="page === -1" class="pagination-btn ellipsis" disabled>
                ...
              </button>
              <button *ngIf="page !== -1" class="pagination-btn page-btn" [class.active]="page === currentPage"
                (click)="goToPage(page)">
                {{ page + 1 }}
              </button>
            </ng-container>

            <button class="pagination-btn next-btn" [disabled]="currentPage >= totalPages - 1"
              (click)="goToNextPage()">
              &gt;
            </button>
            <button class="pagination-btn last-btn" [disabled]="currentPage >= totalPages - 1" (click)="goToPage(totalPages - 1)">
              {{ 'pages.plans.pagination.last' | i18n }}
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="planPanels.length === 0" class="empty-state">
        <h3 class="empty-title">{{ 'pages.plans.empty.title' | i18n }}</h3>
      </div>
    </div>
  </div>
  <umkt-error-display
      *ngIf="error"
      [retryCount]="retryCount"
      (retry)="handleRetry()">
    </umkt-error-display>
</div>